var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-container",
                        { attrs: { fluid: "" } },
                        [
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c("v-col", { attrs: { cols: "12" } }, [
                                _c("h2", [
                                  _vm._v(
                                    "Edit Prices (" +
                                      _vm._s(_vm.units.length) +
                                      " Units)"
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "All prices are in " +
                                      _vm._s(_vm.reservation.hotel.hotel_name) +
                                      "'s local currency " +
                                      _vm._s(
                                        _vm.reservation.hotel.currency
                                          .currency_name
                                      )
                                  ),
                                ]),
                                _vm._v(" "),
                                _vm.reservation.hotel.currency.currency_code !=
                                "GBP"
                                  ? _c("p", [
                                      _vm._v(
                                        "Exchange rate for this record: " +
                                          _vm._s(
                                            _vm.reservation.quote_exchange_rate
                                          ) +
                                          _vm._s(
                                            _vm.reservation.hotel.currency
                                              .currency_code
                                          ) +
                                          " to 1GBP"
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              !_vm.units.length
                                ? _c("v-col", { attrs: { cols: "12" } }, [
                                    _vm._v(
                                      "\n                                    This enquiry has no units yet.  Please provide some before setting prices\n                                    "
                                    ),
                                    _c(
                                      "div",
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            on: {
                                              click: _vm.switchToEditRooms,
                                            },
                                          },
                                          [_vm._v("Edit Rooms and Rates")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.units.length
                                ? _c(
                                    "v-col",
                                    { attrs: { cols: "12" } },
                                    _vm._l(_vm.units, function (unit, index) {
                                      return _c("div", [
                                        _c(
                                          "fieldset",
                                          [
                                            _c("legend", [
                                              _vm._v(
                                                "Unit " +
                                                  _vm._s(index + 1) +
                                                  ": " +
                                                  _vm._s(unit.roomTypeName)
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "v-layout",
                                              { attrs: { row: "" } },
                                              [
                                                _c(
                                                  "v-col",
                                                  { attrs: { cols: "12" } },
                                                  [
                                                    _vm._v(
                                                      "\n                                                   " +
                                                        _vm._s(
                                                          unit.guests.adults
                                                            ? unit.guests
                                                                .adults +
                                                                " adults"
                                                            : ""
                                                        ) +
                                                        "\n                                                   " +
                                                        _vm._s(
                                                          unit.guests
                                                            .olderChildren
                                                            ? unit.guests
                                                                .olderChildren +
                                                                " older children"
                                                            : ""
                                                        ) +
                                                        "\n                                                   " +
                                                        _vm._s(
                                                          unit.guests
                                                            .youngChildren
                                                            ? unit.guests
                                                                .youngChildren +
                                                                " children"
                                                            : ""
                                                        ) +
                                                        "\n                                                   " +
                                                        _vm._s(
                                                          unit.guests.babies
                                                            ? unit.guests
                                                                .babies +
                                                                " babies"
                                                            : ""
                                                        ) +
                                                        ",\n                                                   " +
                                                        _vm._s(
                                                          unit.rateTypeName
                                                        ) +
                                                        "\n                                            "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-col",
                                                  {
                                                    staticClass: "pa-1",
                                                    attrs: {
                                                      cols: "6",
                                                      md: "3",
                                                    },
                                                  },
                                                  [
                                                    _c("strong", [
                                                      _vm._v("Date"),
                                                    ]),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-col",
                                                  {
                                                    staticClass: "pa-1",
                                                    attrs: {
                                                      cols: "6",
                                                      md: "3",
                                                    },
                                                  },
                                                  [
                                                    _c("strong", [
                                                      _vm._v(
                                                        "Rate Amount (" +
                                                          _vm._s(
                                                            _vm.reservation
                                                              .hotel.currency
                                                              .currency_code
                                                          ) +
                                                          ")"
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-col",
                                                  {
                                                    staticClass: "pa-1",
                                                    attrs: {
                                                      cols: "6",
                                                      md: "3",
                                                    },
                                                  },
                                                  [
                                                    _c("strong", [
                                                      _vm._v("Commission %"),
                                                    ]),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-col",
                                                  {
                                                    staticClass: "pa-1",
                                                    attrs: {
                                                      cols: "6",
                                                      md: "3",
                                                    },
                                                  },
                                                  [
                                                    _c("strong", [
                                                      _vm._v(
                                                        "Commission Amount (" +
                                                          _vm._s(
                                                            _vm.reservation
                                                              .hotel.currency
                                                              .currency_code
                                                          ) +
                                                          ")"
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm._l(
                                                  unit.pricesPerDate,
                                                  function (datePrice) {
                                                    return _c(
                                                      "v-col",
                                                      { attrs: { cols: "12" } },
                                                      [
                                                        _c(
                                                          "v-layout",
                                                          {
                                                            attrs: { row: "" },
                                                          },
                                                          [
                                                            _c(
                                                              "v-col",
                                                              {
                                                                staticClass:
                                                                  "pa-1",
                                                                attrs: {
                                                                  cols: "6",
                                                                  md: "3",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.dateFormatDDMYYYYDay(
                                                                      datePrice.date
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "v-col",
                                                              {
                                                                staticClass:
                                                                  "pa-1",
                                                                attrs: {
                                                                  cols: "6",
                                                                  md: "3",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "v-text-field",
                                                                  {
                                                                    on: {
                                                                      change:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.recalcCommAmount(
                                                                            datePrice
                                                                          )
                                                                        },
                                                                      keyup:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.recalcCommAmount(
                                                                            datePrice
                                                                          )
                                                                        },
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        datePrice.rateAmount,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            datePrice,
                                                                            "rateAmount",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "datePrice.rateAmount",
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "v-col",
                                                              {
                                                                staticClass:
                                                                  "pa-1",
                                                                attrs: {
                                                                  cols: "6",
                                                                  md: "3",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "v-text-field",
                                                                  {
                                                                    on: {
                                                                      change:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.recalcCommAmount(
                                                                            datePrice
                                                                          )
                                                                        },
                                                                      keyup:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.recalcCommAmount(
                                                                            datePrice
                                                                          )
                                                                        },
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        datePrice.commissionPercentage,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            datePrice,
                                                                            "commissionPercentage",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "datePrice.commissionPercentage",
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "v-col",
                                                              {
                                                                staticClass:
                                                                  "pa-1",
                                                                attrs: {
                                                                  cols: "6",
                                                                  md: "3",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "v-text-field",
                                                                  {
                                                                    on: {
                                                                      change:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.recalcCommPercentage(
                                                                            datePrice
                                                                          )
                                                                        },
                                                                      keyup:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.recalcCommPercentage(
                                                                            datePrice
                                                                          )
                                                                        },
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        datePrice.commissionAmount,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            datePrice,
                                                                            "commissionAmount",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "datePrice.commissionAmount",
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  }
                                                ),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                      ])
                                    }),
                                    0
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { title: "Cancel without changes" },
                          on: { click: _vm.cancel },
                        },
                        [_vm._v("Cancel")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ies-green",
                          attrs: {
                            title: "Save the changes to the reservation",
                          },
                          on: { click: _vm.saveChanges },
                        },
                        [_vm._v("Save")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }